ORDER_RECHECK_INTERVAL = 60000*3

RealTimeService = Em.Service.extend Em.Evented,
  session:  Em.inject.service()
  store:    Em.inject.service()
  env:      Em.inject.service('environment')
  notifier: Em.inject.service()

  init: ->
    @_super(arguments...)
    Em.Logger.log 'Сервис мгновенных уведомлений запущен'

  newOrderIds: Em.A([])

  clearNewOrderIdsOnSessionChanged: (->
    @get('newOrderIds').clear()
  ).observes('session.currentUser')

  ###
  # Экземпляр транспорта
  ###
  ioClient: ->
    client = @get('ioClientInstance')
    return client if client

    client = new Faye.Client(@get('env.fayeUrl'))
    @set('ioClientInstance', client)
    client

  broadcast: (data)->
    @get('broadcasts').forEach (b)=>

      user = @get('session.currentUser')
      return unless user

      data.api_user_id = user.get('id')
      data.api_user_name = user.get('name')

      @ioClient().publish(b, data)

  ###
  #
  ###
  registerNotifications: (type, id, handler) ->
    channel = "/#{type}/#{id}"
    Em.Logger.log "Пытаемся подключиться к каналу #{channel}"

    subscription = @ioClient().subscribe(channel, handler)

    subscription.then ->
      Em.Logger.log "Подключились к каналу #{channel}"
    , ->
      Em.Logger.error "Ошибка подключения к каналу #{channel}"
    subscription

  cancelSubscriptions: ->
    subs = @get('subscriptions')
    return unless subs
    subs.forEach (s) -> s.cancel()

  ###
  # Приводит к обновлению подписки при изменении текущего пользователя
  ###
  onCurrentUserChanged: (->
    @cancelSubscriptions()

    user = @get('session.currentUser')
    return unless user

    subs = [
      @registerNotifications('api_users', user.get('id'), @ioHandler.bind(@))
    ]

    broadcasts = []
    @get('session.availableOrganizations').forEach (o)=>
      subs.push @registerNotifications('organization', o.get('id'), @ioHandler.bind(@))
      broadcasts.push "/organization/#{o.get('id')}"

    @set('subscriptions', subs)
    @set('broadcasts', broadcasts)
  ).observes('session.currentUser').on('init')

  orderNotificationText: (order) ->
    delivery = moment(order.get('delivery_at')).format('D MMMM, HH:mm')
    # todo i18n
    order_text = "#{delivery}, Заказ ##{order.get('number')}"


  ####
  # Инвалидация устаревших состояний просмотра заказа
  ####

  recheckViewingOrders: ->

    ORDER_VIEWED_BY_TTL = @get('env').get('orderViewedByInterval') || 5000

    openedOrders = @get('session.openedOrders')
    updated = false

    Object.keys(openedOrders).forEach (order) ->
      Object.keys(openedOrders[order]).forEach (viewer) ->
        if new Date - openedOrders[order][viewer].timestamp > ORDER_VIEWED_BY_TTL * 2
          delete openedOrders[order][viewer]
          updated = true

    @get('session').set('openedOrders', openedOrders)
    # попробовать incrementProperty
    @get('session').set('openedOrdersCount', @get('session.openedOrdersCount')+1)

    Em.run.later(@recheckViewingOrders.bind(@), ORDER_VIEWED_BY_TTL / 1.2)

  runRecheckViewingOrders: (->
    @recheckViewingOrders()
    Em.run.later(@recheckOrders.bind(@), ORDER_RECHECK_INTERVAL)
  ).on('init')


  ####
  # Обработка PubSub событий
  ####

  recheckOrders: ->
    # иногда случается так, что заказы не прихоодят, поэтому раз в ORDER_RECHECK_INTERVAL проверяем список активных заказов
    adapter = @get('store').adapterFor(App.Order)
    ajaxProps =
      url:     adapter.buildURL('Order', @get('id'))
      headers: adapter.get('headers')
      type:    'GET'
      # вот эти вот 400 заказов надо вынести в настройки, и параметры зарпоса тоже надо брать из списка заказов
      data: {active: true, active_ids: true, page_size: 400, "sort[]": 'delivery_at ASC', "status[]": ['pending','confirm', 'delivery', 'preparing', 'prepared']}

    new Em.RSVP.Promise (resolve, reject) =>
      Em.$.ajax(Em.merge(ajaxProps, {})).then(resolve, reject)
    .then (data) =>
      if data && data.orders
        data.orders.forEach (order_id) =>
          order = @get('store').getById('order', order_id)
          unless order
            Em.Logger.log("[realtime] Нашли потерянный заказ id: #{order_id}, подгружаем его")
            @get('store').find('order', order_id)
            .then (order) =>
              @trigger('orderCreated', order)

    Em.run.later(@recheckOrders.bind(@), ORDER_RECHECK_INTERVAL)



  ioHandler: (message) ->
    # Em.Logger.log "Сообщение #{message.type}"
    notificationDuration = 30000

    ###
    # Пришел новый заказ или был назначен на курьера
    ###
    switch message.type
      when 'incoming_call'
        phone = message.local_number or message.number
        @trigger('incoming_call', phone)

      when 'order_created'
        order_id = message.order_payload.order.id

        @get('store').pushPayload('order', message.order_payload)
        order = @get('store').getById('order', order_id)

        @trigger('orderCreated', order)
        @get('newOrderIds').addObject(order.get('id'))

      when 'order_updated','order_message'
        id = message.order_id
        @get('store').find('order', id)
        .then (order) =>
          if order && !order.get('isDirty')
            old_payment_success = order.get('payment_success')
            @get('store').pushPayload('order', message.order_payload)
            # params = message.order_payload?.order?.integration_params
            
            # if params
            #   errorKey = Object.keys(params).find (key) => params[key]?.error
            #   if errorKey
            #     @get('notifier').pushNotification
            #       type:'error'
            #       title: Em.I18n.t 'order.edit.pos_error.label'
            #       message: params[errorKey]?.error_message || "##{order.get('number')}"
            #       handler: =>
            #         App.__container__.lookup('controller:application').transitionToRoute 'orders.map.order.detailed', order

            if old_payment_success != order.get('payment_success') && order.get('payment_success')
              @trigger('orderPaid', order)

          if message.type == 'order_message'
            @trigger('orderMessageSent', order, message.message_text)
        .catch () =>

        # false

      when 'order_cooking_start'
        id = message.order_id
        pick_up_at = message.pick_up_at

        @get('store').find('order', id)
        .then (order) =>
          @trigger('orderCookingStart', order, pick_up_at)

      # TODO
      # Этот и следующий методы хорошо бы унифицировать и убрать куда-нибудь в сессию или заказ
      #

      when 'order_window_opened'
        id = message.order_id
        return if @get('session.currentUser.id') == message.api_user_id

        openedOrders = @get('session.openedOrders')

        openedOrders[id] = {} unless openedOrders[id]
        openedOrders[id][message.api_user_id] = {
          user_name: message.api_user_name,
          user_id: message.api_user_id,
          timestamp: new Date
        }
        @get('session').set('openedOrders', openedOrders)
        @get('session').set('openedOrdersCount', @get('session.openedOrdersCount')+1)

      when 'order_window_closed'
        id = message.order_id
        return if @get('session.currentUser.id') == message.api_user_id

        openedOrders = @get('session.openedOrders')
        openedOrders[id] = {} unless openedOrders[id]

        return unless openedOrders[id][message.api_user_id]

        delete openedOrders[id][message.api_user_id]

        @get('session').set('openedOrders', openedOrders)
        @get('session').set('openedOrdersCount', @get('session.openedOrdersCount')+1)

      when 'order_status_changed'
        id = message.order_id
        status = message.status
        status_was = message.status_was

        @get('store').find('order', id)
        .then (order) =>
          @get('store').push('order', { id, status })
          order.set 'status', status

          @trigger('orderStatusChanged', order, status, status_was)

      when 'order_restaurant_confirmed'
        id = message.order_id
        confirmed_at = message.confirmed_at

        @get('store').find('order', id)
        .then (order) =>
          @get('store').push('order', { id, restaurant_confirmed_at: confirmed_at })
          @trigger('orderRestaurantConfirmed', order, confirmed_at)

      when 'order_courier_confirmed'
        id = message.order_id
        courier_id   = message.courier_id
        confirmed_at = message.confirmed_at

        @get('store').find('order', id)
        .then (order) =>
          @get('store').find('courier', courier_id)
          .then (courier) =>
            @get('store').push('order', { id, courier_confirmed_at: confirmed_at })
            @trigger('orderCourierConfirmed', order, courier, confirmed_at)

      when 'order_pos_error'
        id = message.order_id
        @get('store').find('order', id).then (order) => 
          @get('notifier').pushNotification
            type: 'error'
            title: "##{order.get('number')} #{Em.I18n.t 'order.edit.pos_error.label'}" 
            message: message.error_message
            handler: =>
              App.__container__.lookup('controller:application').transitionToRoute 'orders.map.order.detailed', order
      
      when 'client_message_created'
        @trigger('clientMessageCreated', JSON.parse(message.client_message_payload)?.client_message)
      
      when 'client_message_updated'
        @trigger('clientMessageUpdated', message)

      when 'unprocessed_counts_updated'
        @trigger('unprocessedCountsUpdated', message)

      when 'communication_channel_updated'
        @trigger('communicationChannelUpdated', message)



module.exports = RealTimeService
